/** A row's vertical extent in viewport coordinates. */
export interface RowSpan {
  top: number;
  bottom: number;
}

const inView = (span: RowSpan, viewportHeight: number) => span.bottom > 0 && span.top < viewportHeight;

/**
 * Whether a list update pushed the reader's row out of view: the row moved in
 * the page by *moved* px (scrolling moves nothing), from where it was in view
 * to where it is not. A row the reader scrolled away was already out of view,
 * so it never counts.
 */
export function pushedOutOfView(now: RowSpan, moved: number, viewportHeight: number): boolean {
  if (Math.abs(moved) < 1) return false;
  return !inView(now, viewportHeight) && inView({ top: now.top - moved, bottom: now.bottom - moved }, viewportHeight);
}
